import { render } from "./SuperMenu.vue?vue&type=template&id=b1d28e0c&scoped=true&ts=true"
import script from "./SuperMenu.vue?vue&type=script&lang=ts"
export * from "./SuperMenu.vue?vue&type=script&lang=ts"

import "./SuperMenu.vue?vue&type=style&index=0&id=b1d28e0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1d28e0c"]])

export default __exports__